const DISMISSED_KEY = 'in-app-browser-notice:dismissed';

// Storage can throw in private windows or with blocked site data; the notice
// then shows again, which is the safe side.
export const isInAppBrowserNoticeDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const dismissInAppBrowserNotice = (): void => {
  try {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
  } catch {
    // The in-memory state still hides it for this page.
  }
};
